import { Card } from "react-bootstrap";
import i18n from "i18next";
import { ResolvedDocumentAttachment } from "../../services/document/DocumentAttachmentService";
import { PapyrusDocumentRepresentation } from "../../services/document/DocumentModels";

type FhirStructuredViewerProps = {
    representation: PapyrusDocumentRepresentation;
    resolvedAttachment?: ResolvedDocumentAttachment;
};

export default function FhirStructuredViewer({ representation, resolvedAttachment }: FhirStructuredViewerProps) {
    const content = resolvedAttachment?.json
        ? JSON.stringify(resolvedAttachment.json, null, 2)
        : resolvedAttachment?.text ?? "";

    return (
        <Card>
            <Card.Body>
                <Card.Title>{i18n.t("viewer.fhir")}</Card.Title>
                <Card.Subtitle className="mb-2 text-muted">
                    {representation.contentType}
                </Card.Subtitle>
                {content ? (
                    <pre className="bg-light p-3 border rounded overflow-auto">
                        {content}
                    </pre>
                ) : (
                    <Card.Text>{i18n.t("viewer.nofhir")}</Card.Text>
                )}
            </Card.Body>
        </Card>
    );
}
